/* eslint-disable */
import * as yup from 'yup'
import { AddAssetMediaInput, AddUserPermissionInput, AddUserSignatureInput, AddressInput, AssetElementInput, AssetInput, AssetPresentValueInput, CertificateInput, ChangePasswordInput, CreateAssetElementInput, CreateAssetInput, CreateAssetPresentValueInput, CreateCertificateInput, CreateInsuranceInput, CreateOfficeInput, CreatePolicyAssetInput, CreatePolicyDocumentInput, CreatePolicyInput, CreatePolicyNoteInput, CreateRegistryInput, CreateUserInput, DeleteAssetElementInput, DeleteAssetInput, DeleteAssetPresentValueInput, DeleteCertificateInput, DeleteInsuranceInput, DeleteOfficeInput, DeletePolicyAssetInput, DeletePolicyDocumentInput, DeletePolicyInput, DeletePolicyNoteInput, DeleteRegistryInput, DeleteUserInput, DeleteUserSignatureInput, GenerateCertificateInput, InsuranceInput, InviteUserInput, ManagementAssetAudioVideoLengthUnitChoices, ManagementAssetCarryingValueAcquisitionChoices, ManagementAssetCarryingValueAmountCurrencyChoices, ManagementAssetCategoryChoices, ManagementAssetCenturyEndDateWindowChoices, ManagementAssetCenturyStartDateWindowChoices, ManagementAssetDatingTypeChoices, ManagementAssetFileSizeUnitChoices, ManagementAssetFrameMaterialChoices, ManagementAssetGrossDimensionsAcquisitionChoices, ManagementAssetGrossLengthUnitChoices, ManagementAssetGrossWeightUnitChoices, ManagementAssetInjuryRiskChoices, ManagementAssetLightUnitChoices, ManagementAssetNetDimensionsAcquisitionChoices, ManagementAssetNetLengthUnitChoices, ManagementAssetNetWeightUnitChoices, ManagementAssetPresentValueAmountCurrencyChoices, ManagementAssetPresentValueEstimateReasonChoices, ManagementAssetResolutionUnitChoices, ManagementAssetStampCenteringAndMarginsChoices, ManagementAssetStampFormatChoices, ManagementAssetStampIndentationTypeChoices, ManagementAssetStampPrintingTechniqueChoices, ManagementAssetStampRealizationChoices, ManagementAssetSubcategoryChoices, ManagementAssetTemperatureUnitChoices, ManagementInsuranceContractTypeChoices, ManagementInsuranceCoverageTypeChoices, ManagementInsuranceEvaluationTypeChoices, ManagementInsuranceInsuranceReasonChoices, ManagementInsuranceRiskCoveredTypeChoices, MoneyInput, OfficeInput, PolicyAssetInput, PolicyDocumentInput, PolicyInput, PolicyNoteInput, RbacClientCustomerTypeChoices, RbacClientTierChoices, RegistryInput, RequestUserResetPasswordInput, ResetUserPasswordInput, SignCertificateInput, SpinCertificateCertificateTypeChoices, ToggleUserIsActiveInput, ToggleUserUserTypeInput, UpdateAssetElementInput, UpdateAssetInput, UpdateAssetPresentValueInput, UpdateCertificateInput, UpdateInsuranceInput, UpdateOfficeInput, UpdatePolicyAssetInput, UpdatePolicyDocumentInput, UpdatePolicyInput, UpdatePolicyNoteInput, UpdateRegistryInput, UpdateUserInput, UpdateUserPermissionInput, UserInput, UsersUserUserTypeChoices } from './queries'

export function AddAssetMediaInputSchema(): yup.SchemaOf<AddAssetMediaInput> {
  return yup.object({
    assetId: yup.string().required(),
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    file: (yup.mixed().defined() as any).defined()
  })
}

export function AddUserPermissionInputSchema(): yup.SchemaOf<AddUserPermissionInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    email: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    permissionNames: yup.array().of(yup.string()).optional()
  })
}

export function AddUserSignatureInputSchema(): yup.SchemaOf<AddUserSignatureInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    file: (yup.mixed().defined() as any).defined(),
    name: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    userId: yup.string().required()
  })
}

export function AddressInputSchema(): yup.SchemaOf<AddressInput> {
  return yup.object({
    formatted: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    latitude: yup.number(),
    longitude: yup.number(),
    raw: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    route: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    streetNumber: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function AssetElementInputSchema(): yup.SchemaOf<AssetElementInput> {
  return yup.object({
    assetId: yup.string(),
    description: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    materials: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    name: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    notes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function AssetInputSchema(): yup.SchemaOf<AssetInput> {
  return yup.object({
    archiveNumber: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    artistProofNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    assetPresentValues: yup.array().of(yup.lazy(() => yup.mixed()) as never).optional(),
    author: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    authorEntityId: yup.string().required(),
    barriersDetails: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    baseDetails: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    bibliographyNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    carryingValueAcquisition: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    carryingValueAmount: yup.lazy(() => yup.mixed()) as never,
    carryingValueFile: (yup.mixed().defined() as any),
    carryingValueFileTitle: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    carryingValueLastAcquisitionDate: yup.mixed(),
    carryingValueNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    carryingValueOrigin: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    catalogNumber: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    category: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    centuryEndDate: yup.number().transform((value) => (isNaN(value) ? undefined:value)).nullable(),
    centuryEndDateWindow: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    centuryStartDate: yup.number().transform((value) => (isNaN(value) ? undefined:value)).nullable(),
    centuryStartDateWindow: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    conservation: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    copyrightAndPropertyRestrictions: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    creationDate: yup.mixed(),
    creationPeriod: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    criticalCatalogue: yup.boolean(),
    dateEndDate: yup.mixed(),
    dateStartDate: yup.mixed(),
    datedObjectNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    datingType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    description: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    dimensionsNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    enviromentalConditionsNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    grossDepth: yup.number().transform((value) => (isNaN(value) ? undefined:value)).nullable(),
    grossDiameter: yup.number().transform((value) => (isNaN(value) ? undefined:value)).nullable(),
    grossDimensionsAcquisition: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    grossHeight: yup.number().transform((value) => (isNaN(value) ? undefined:value)).nullable(),
    grossLengthUnit: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    grossWeight: yup.number().transform((value) => (isNaN(value) ? undefined:value)).nullable(),
    grossWeightUnit: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    grossWidth: yup.number().transform((value) => (isNaN(value) ? undefined:value)).nullable(),
    handlingRequirements: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    hardwareToolsInstallation: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    hasBarriers: yup.boolean(),
    hasBase: yup.boolean(),
    hasFullDatetime: yup.boolean(),
    hasLabelsStamps: yup.boolean(),
    hasOtherAutographed: yup.boolean(),
    hasPeriod: yup.boolean(),
    hasWoodFrame: yup.boolean(),
    hasYear: yup.boolean(),
    infoNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    injuryRisk: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    injuryRiskDescription: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    inventoryNumber: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    isArtMultiple: yup.boolean(),
    isArtistProof: yup.boolean(),
    isCenturyApprox: yup.boolean(),
    isCenturyEndDateBc: yup.boolean(),
    isCenturyInterval: yup.boolean(),
    isCenturyStartDateBc: yup.boolean(),
    isComposed: yup.boolean(),
    isDateApprox: yup.boolean(),
    isDateEndDateBc: yup.boolean(),
    isDateInterval: yup.boolean(),
    isDateStartDateBc: yup.boolean(),
    isDatedObject: yup.boolean(),
    isNotifiedCulturalProperty: yup.boolean(),
    isSignedObject: yup.boolean(),
    isTitledObject: yup.boolean(),
    isYearApprox: yup.boolean(),
    isYearEndDateBc: yup.boolean(),
    isYearInterval: yup.boolean(),
    isYearStartDateBc: yup.boolean(),
    labelsStampsNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    legalStatus: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    lenderRequests: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    lightUnit: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    mouldingSupportBase: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    multipleNumber: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    netDepth: yup.number().transform((value) => (isNaN(value) ? undefined:value)).nullable(),
    netDiameter: yup.number().transform((value) => (isNaN(value) ? undefined:value)).nullable(),
    netDimensionsAcquisition: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    netHeight: yup.number().transform((value) => (isNaN(value) ? undefined:value)).nullable(),
    netLengthUnit: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    netWeight: yup.number().transform((value) => (isNaN(value) ? undefined:value)).nullable(),
    netWeightUnit: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    netWidth: yup.number().transform((value) => (isNaN(value) ? undefined:value)).nullable(),
    nft: yup.boolean(),
    nftNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    notifiedPropertyNote: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    numberOfElements: yup.number().transform((value) => (isNaN(value) ? undefined:value)).nullable(),
    optimalHumidity: yup.number().transform((value) => (isNaN(value) ? undefined:value)).nullable(),
    optimalLightLevelIntensity: yup.number().transform((value) => (isNaN(value) ? undefined:value)).nullable(),
    optimalTemperature: yup.number().transform((value) => (isNaN(value) ? undefined:value)).nullable(),
    originNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    otherAutographedNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    physicalFeaturesElements: yup.array().of(yup.lazy(() => yup.mixed()) as never).optional(),
    relevantAwards: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    series: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    seriesDetails: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    settingNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    signedObjectNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    sku: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    subcategory: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    surfaceCharacteristics: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    temperatureUnit: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    title: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    titledObjectNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    validated: yup.boolean().defined(),
    woodFrameDetails: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    yearEndDate: yup.number().transform((value) => (isNaN(value) ? undefined:value)).nullable(),
    yearStartDate: yup.number().transform((value) => (isNaN(value) ? undefined:value)).nullable()
  })
}

export function AssetPresentValueInputSchema(): yup.SchemaOf<AssetPresentValueInput> {
  return yup.object({
    amount: yup.lazy(() => yup.mixed()) as never,
    assetId: yup.string(),
    authorId: yup.string(),
    estimateDate: yup.mixed(),
    estimateReason: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    file: (yup.mixed().defined() as any),
    fileTitle: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    notes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function CertificateInputSchema(): yup.SchemaOf<CertificateInput> {
  return yup.object({
    cancelReplace: yup.boolean(),
    cancelReplaceNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    certificateType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    creationDate: yup.mixed(),
    language: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    notes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    printTemplate: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function ChangePasswordInputSchema(): yup.SchemaOf<ChangePasswordInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    confirmPassword: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    email: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    newPassword: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    oldPassword: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required()
  })
}

export function CreateAssetElementInputSchema(): yup.SchemaOf<CreateAssetElementInput> {
  return yup.object({
    assetElementData: yup.lazy(() => yup.mixed()) as never,
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function CreateAssetInputSchema(): yup.SchemaOf<CreateAssetInput> {
  return yup.object({
    assetData: yup.lazy(() => yup.mixed()) as never,
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function CreateAssetPresentValueInputSchema(): yup.SchemaOf<CreateAssetPresentValueInput> {
  return yup.object({
    assetPresentValueData: yup.lazy(() => yup.mixed()) as never,
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function CreateCertificateInputSchema(): yup.SchemaOf<CreateCertificateInput> {
  return yup.object({
    certificateData: yup.lazy(() => yup.mixed()) as never,
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function CreateInsuranceInputSchema(): yup.SchemaOf<CreateInsuranceInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    insuranceData: yup.lazy(() => yup.mixed()) as never
  })
}

export function CreateOfficeInputSchema(): yup.SchemaOf<CreateOfficeInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    officeData: yup.lazy(() => yup.mixed()) as never
  })
}

export function CreatePolicyAssetInputSchema(): yup.SchemaOf<CreatePolicyAssetInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    policyAssetData: yup.lazy(() => yup.mixed()) as never
  })
}

export function CreatePolicyDocumentInputSchema(): yup.SchemaOf<CreatePolicyDocumentInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    file: (yup.mixed().defined() as any).defined(),
    name: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function CreatePolicyInputSchema(): yup.SchemaOf<CreatePolicyInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    policyData: yup.lazy(() => yup.mixed()) as never
  })
}

export function CreatePolicyNoteInputSchema(): yup.SchemaOf<CreatePolicyNoteInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    policyNoteData: yup.lazy(() => yup.mixed()) as never
  })
}

export function CreateRegistryInputSchema(): yup.SchemaOf<CreateRegistryInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    registryData: yup.lazy(() => yup.mixed()) as never
  })
}

export function CreateUserInputSchema(): yup.SchemaOf<CreateUserInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    email: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    userData: yup.lazy(() => yup.mixed()) as never
  })
}

export function DeleteAssetElementInputSchema(): yup.SchemaOf<DeleteAssetElementInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string()
  })
}

export function DeleteAssetInputSchema(): yup.SchemaOf<DeleteAssetInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DeleteAssetPresentValueInputSchema(): yup.SchemaOf<DeleteAssetPresentValueInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string()
  })
}

export function DeleteCertificateInputSchema(): yup.SchemaOf<DeleteCertificateInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string()
  })
}

export function DeleteInsuranceInputSchema(): yup.SchemaOf<DeleteInsuranceInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DeleteOfficeInputSchema(): yup.SchemaOf<DeleteOfficeInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DeletePolicyAssetInputSchema(): yup.SchemaOf<DeletePolicyAssetInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DeletePolicyDocumentInputSchema(): yup.SchemaOf<DeletePolicyDocumentInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string()
  })
}

export function DeletePolicyInputSchema(): yup.SchemaOf<DeletePolicyInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DeletePolicyNoteInputSchema(): yup.SchemaOf<DeletePolicyNoteInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DeleteRegistryInputSchema(): yup.SchemaOf<DeleteRegistryInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DeleteUserInputSchema(): yup.SchemaOf<DeleteUserInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function DeleteUserSignatureInputSchema(): yup.SchemaOf<DeleteUserSignatureInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function GenerateCertificateInputSchema(): yup.SchemaOf<GenerateCertificateInput> {
  return yup.object({
    cancelReplace: yup.boolean(),
    cancelReplaceNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    certificateTemplateId: yup.string(),
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    hasPdf: yup.boolean(),
    id: yup.string(),
    language: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    notes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function InsuranceInputSchema(): yup.SchemaOf<InsuranceInput> {
  return yup.object({
    catNat: yup.boolean().defined(),
    contractType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    coverageType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    currencyInsurancePremium: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    currencyInsuredValue: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    evaluationType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    insurancePremium: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    insuranceReason: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    insuredValue: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    note: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    policyNumber: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    riskCoveredType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    terrorism: yup.boolean().defined()
  })
}

export function InviteUserInputSchema(): yup.SchemaOf<InviteUserInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    email: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    expiresAt: yup.mixed().defined(),
    permissions: yup.array().of(yup.string().transform((value) =>( value === null ? undefined:value)).nullable()).optional()
  })
}

export const ManagementAssetAudioVideoLengthUnitChoicesSchema = yup.mixed().oneOf([ManagementAssetAudioVideoLengthUnitChoices.A, ManagementAssetAudioVideoLengthUnitChoices.H, ManagementAssetAudioVideoLengthUnitChoices.M, ManagementAssetAudioVideoLengthUnitChoices.S]);

export const ManagementAssetCarryingValueAcquisitionChoicesSchema = yup.mixed().oneOf([ManagementAssetCarryingValueAcquisitionChoices.A, ManagementAssetCarryingValueAcquisitionChoices.Gift, ManagementAssetCarryingValueAcquisitionChoices.Inherited, ManagementAssetCarryingValueAcquisitionChoices.Other, ManagementAssetCarryingValueAcquisitionChoices.Purchased]);

export const ManagementAssetCarryingValueAmountCurrencyChoicesSchema = yup.mixed().oneOf([ManagementAssetCarryingValueAmountCurrencyChoices.Eur, ManagementAssetCarryingValueAmountCurrencyChoices.Usd]);

export const ManagementAssetCategoryChoicesSchema = yup.mixed().oneOf([ManagementAssetCategoryChoices.Archeologic, ManagementAssetCategoryChoices.DesignOrAntique, ManagementAssetCategoryChoices.Digital, ManagementAssetCategoryChoices.Installation, ManagementAssetCategoryChoices.Naturalistic, ManagementAssetCategoryChoices.NotValidated, ManagementAssetCategoryChoices.Numismatic, ManagementAssetCategoryChoices.Other, ManagementAssetCategoryChoices.Painting, ManagementAssetCategoryChoices.Philately, ManagementAssetCategoryChoices.PrintOrPhoto, ManagementAssetCategoryChoices.Sculpture, ManagementAssetCategoryChoices.Urban]);

export const ManagementAssetCenturyEndDateWindowChoicesSchema = yup.mixed().oneOf([ManagementAssetCenturyEndDateWindowChoices.A, ManagementAssetCenturyEndDateWindowChoices.Begin, ManagementAssetCenturyEndDateWindowChoices.End, ManagementAssetCenturyEndDateWindowChoices.FirstHalf, ManagementAssetCenturyEndDateWindowChoices.Half, ManagementAssetCenturyEndDateWindowChoices.SecondHalf]);

export const ManagementAssetCenturyStartDateWindowChoicesSchema = yup.mixed().oneOf([ManagementAssetCenturyStartDateWindowChoices.A, ManagementAssetCenturyStartDateWindowChoices.Begin, ManagementAssetCenturyStartDateWindowChoices.End, ManagementAssetCenturyStartDateWindowChoices.FirstHalf, ManagementAssetCenturyStartDateWindowChoices.Half, ManagementAssetCenturyStartDateWindowChoices.SecondHalf]);

export const ManagementAssetDatingTypeChoicesSchema = yup.mixed().oneOf([ManagementAssetDatingTypeChoices.A, ManagementAssetDatingTypeChoices.Century, ManagementAssetDatingTypeChoices.Date, ManagementAssetDatingTypeChoices.Period, ManagementAssetDatingTypeChoices.Year]);

export const ManagementAssetFileSizeUnitChoicesSchema = yup.mixed().oneOf([ManagementAssetFileSizeUnitChoices.A, ManagementAssetFileSizeUnitChoices.Kb, ManagementAssetFileSizeUnitChoices.Mb, ManagementAssetFileSizeUnitChoices.Tb]);

export const ManagementAssetFrameMaterialChoicesSchema = yup.mixed().oneOf([ManagementAssetFrameMaterialChoices.A, ManagementAssetFrameMaterialChoices.Fabric, ManagementAssetFrameMaterialChoices.Laminate, ManagementAssetFrameMaterialChoices.Metal, ManagementAssetFrameMaterialChoices.MultiMaterial, ManagementAssetFrameMaterialChoices.Paper, ManagementAssetFrameMaterialChoices.Perspex, ManagementAssetFrameMaterialChoices.Plastic, ManagementAssetFrameMaterialChoices.Stone, ManagementAssetFrameMaterialChoices.Wood]);

export const ManagementAssetGrossDimensionsAcquisitionChoicesSchema = yup.mixed().oneOf([ManagementAssetGrossDimensionsAcquisitionChoices.Given, ManagementAssetGrossDimensionsAcquisitionChoices.Measured, ManagementAssetGrossDimensionsAcquisitionChoices.NotMeasured]);

export const ManagementAssetGrossLengthUnitChoicesSchema = yup.mixed().oneOf([ManagementAssetGrossLengthUnitChoices.Cm, ManagementAssetGrossLengthUnitChoices.Ft, ManagementAssetGrossLengthUnitChoices.In, ManagementAssetGrossLengthUnitChoices.M, ManagementAssetGrossLengthUnitChoices.Mm]);

export const ManagementAssetGrossWeightUnitChoicesSchema = yup.mixed().oneOf([ManagementAssetGrossWeightUnitChoices.G, ManagementAssetGrossWeightUnitChoices.Hg, ManagementAssetGrossWeightUnitChoices.Kg, ManagementAssetGrossWeightUnitChoices.Lb, ManagementAssetGrossWeightUnitChoices.Oz]);

export const ManagementAssetInjuryRiskChoicesSchema = yup.mixed().oneOf([ManagementAssetInjuryRiskChoices.Average, ManagementAssetInjuryRiskChoices.High, ManagementAssetInjuryRiskChoices.Low, ManagementAssetInjuryRiskChoices.None]);

export const ManagementAssetLightUnitChoicesSchema = yup.mixed().oneOf([ManagementAssetLightUnitChoices.FootCandles, ManagementAssetLightUnitChoices.Lux]);

export const ManagementAssetNetDimensionsAcquisitionChoicesSchema = yup.mixed().oneOf([ManagementAssetNetDimensionsAcquisitionChoices.Given, ManagementAssetNetDimensionsAcquisitionChoices.Measured, ManagementAssetNetDimensionsAcquisitionChoices.NotMeasured]);

export const ManagementAssetNetLengthUnitChoicesSchema = yup.mixed().oneOf([ManagementAssetNetLengthUnitChoices.Cm, ManagementAssetNetLengthUnitChoices.Ft, ManagementAssetNetLengthUnitChoices.In, ManagementAssetNetLengthUnitChoices.M, ManagementAssetNetLengthUnitChoices.Mm]);

export const ManagementAssetNetWeightUnitChoicesSchema = yup.mixed().oneOf([ManagementAssetNetWeightUnitChoices.G, ManagementAssetNetWeightUnitChoices.Hg, ManagementAssetNetWeightUnitChoices.Kg, ManagementAssetNetWeightUnitChoices.Lb, ManagementAssetNetWeightUnitChoices.Oz]);

export const ManagementAssetPresentValueAmountCurrencyChoicesSchema = yup.mixed().oneOf([ManagementAssetPresentValueAmountCurrencyChoices.Eur, ManagementAssetPresentValueAmountCurrencyChoices.Usd]);

export const ManagementAssetPresentValueEstimateReasonChoicesSchema = yup.mixed().oneOf([ManagementAssetPresentValueEstimateReasonChoices.Alienation, ManagementAssetPresentValueEstimateReasonChoices.AssetAnalysis, ManagementAssetPresentValueEstimateReasonChoices.Cr, ManagementAssetPresentValueEstimateReasonChoices.InsuranceQuote, ManagementAssetPresentValueEstimateReasonChoices.LegalDispute]);

export const ManagementAssetResolutionUnitChoicesSchema = yup.mixed().oneOf([ManagementAssetResolutionUnitChoices.A, ManagementAssetResolutionUnitChoices.K, ManagementAssetResolutionUnitChoices.P]);

export const ManagementAssetStampCenteringAndMarginsChoicesSchema = yup.mixed().oneOf([ManagementAssetStampCenteringAndMarginsChoices.Average, ManagementAssetStampCenteringAndMarginsChoices.A, ManagementAssetStampCenteringAndMarginsChoices.ExtraFine, ManagementAssetStampCenteringAndMarginsChoices.Fine, ManagementAssetStampCenteringAndMarginsChoices.Poor, ManagementAssetStampCenteringAndMarginsChoices.Superb]);

export const ManagementAssetStampFormatChoicesSchema = yup.mixed().oneOf([ManagementAssetStampFormatChoices.A, ManagementAssetStampFormatChoices.Booklet, ManagementAssetStampFormatChoices.Coil, ManagementAssetStampFormatChoices.Sheets]);

export const ManagementAssetStampIndentationTypeChoicesSchema = yup.mixed().oneOf([ManagementAssetStampIndentationTypeChoices.A, ManagementAssetStampIndentationTypeChoices.Block, ManagementAssetStampIndentationTypeChoices.Comb, ManagementAssetStampIndentationTypeChoices.Linear]);

export const ManagementAssetStampPrintingTechniqueChoicesSchema = yup.mixed().oneOf([ManagementAssetStampPrintingTechniqueChoices.A, ManagementAssetStampPrintingTechniqueChoices.Chalcography, ManagementAssetStampPrintingTechniqueChoices.LetterpressPrinting, ManagementAssetStampPrintingTechniqueChoices.Lithography, ManagementAssetStampPrintingTechniqueChoices.Offset, ManagementAssetStampPrintingTechniqueChoices.Photogravure, ManagementAssetStampPrintingTechniqueChoices.ReliefPrinting, ManagementAssetStampPrintingTechniqueChoices.Rotogravure, ManagementAssetStampPrintingTechniqueChoices.Serigraphy]);

export const ManagementAssetStampRealizationChoicesSchema = yup.mixed().oneOf([ManagementAssetStampRealizationChoices.Automatic, ManagementAssetStampRealizationChoices.A, ManagementAssetStampRealizationChoices.Indented, ManagementAssetStampRealizationChoices.NotIndented, ManagementAssetStampRealizationChoices.SelfAdhesive]);

export const ManagementAssetSubcategoryChoicesSchema = yup.mixed().oneOf([ManagementAssetSubcategoryChoices.AntiquesDesign, ManagementAssetSubcategoryChoices.Archeology, ManagementAssetSubcategoryChoices.ArtistProof, ManagementAssetSubcategoryChoices.Audio, ManagementAssetSubcategoryChoices.Automobile, ManagementAssetSubcategoryChoices.A, ManagementAssetSubcategoryChoices.Clothes, ManagementAssetSubcategoryChoices.Drawing, ManagementAssetSubcategoryChoices.DynamicWork, ManagementAssetSubcategoryChoices.Graphic, ManagementAssetSubcategoryChoices.HistoricalObjects, ManagementAssetSubcategoryChoices.Installation, ManagementAssetSubcategoryChoices.Jewelry, ManagementAssetSubcategoryChoices.Lithography, ManagementAssetSubcategoryChoices.Memorabilia, ManagementAssetSubcategoryChoices.MusicalInstruments, ManagementAssetSubcategoryChoices.NaturalSite, ManagementAssetSubcategoryChoices.NumismaticAndBanknotes, ManagementAssetSubcategoryChoices.NumismaticCoinsAndMedals, ManagementAssetSubcategoryChoices.OperaSuCarta, ManagementAssetSubcategoryChoices.OtherBidimensionalWorks, ManagementAssetSubcategoryChoices.Painting, ManagementAssetSubcategoryChoices.Philately, ManagementAssetSubcategoryChoices.Photography, ManagementAssetSubcategoryChoices.Prints, ManagementAssetSubcategoryChoices.Sculpture, ManagementAssetSubcategoryChoices.Serigraphy, ManagementAssetSubcategoryChoices.StaticWork, ManagementAssetSubcategoryChoices.Tapestries, ManagementAssetSubcategoryChoices.Toys, ManagementAssetSubcategoryChoices.UrbanArt, ManagementAssetSubcategoryChoices.Video, ManagementAssetSubcategoryChoices.Watches, ManagementAssetSubcategoryChoices.Wine, ManagementAssetSubcategoryChoices.Xylography]);

export const ManagementAssetTemperatureUnitChoicesSchema = yup.mixed().oneOf([ManagementAssetTemperatureUnitChoices.C, ManagementAssetTemperatureUnitChoices.F]);

export const ManagementInsuranceContractTypeChoicesSchema = yup.mixed().oneOf([ManagementInsuranceContractTypeChoices.Basket, ManagementInsuranceContractTypeChoices.Punctual]);

export const ManagementInsuranceCoverageTypeChoicesSchema = yup.mixed().oneOf([ManagementInsuranceCoverageTypeChoices.NailToNail, ManagementInsuranceCoverageTypeChoices.StayRisk, ManagementInsuranceCoverageTypeChoices.TravelRisk]);

export const ManagementInsuranceEvaluationTypeChoicesSchema = yup.mixed().oneOf([ManagementInsuranceEvaluationTypeChoices.All, ManagementInsuranceEvaluationTypeChoices.DeclaredValue, ManagementInsuranceEvaluationTypeChoices.EstimateAccepted]);

export const ManagementInsuranceInsuranceReasonChoicesSchema = yup.mixed().oneOf([ManagementInsuranceInsuranceReasonChoices.Exhibition, ManagementInsuranceInsuranceReasonChoices.ExhibitionTransport, ManagementInsuranceInsuranceReasonChoices.Loan, ManagementInsuranceInsuranceReasonChoices.Restauration, ManagementInsuranceInsuranceReasonChoices.RestaurationTransport, ManagementInsuranceInsuranceReasonChoices.StayInPlace, ManagementInsuranceInsuranceReasonChoices.Transport]);

export const ManagementInsuranceRiskCoveredTypeChoicesSchema = yup.mixed().oneOf([ManagementInsuranceRiskCoveredTypeChoices.AllRisk, ManagementInsuranceRiskCoveredTypeChoices.FirstRisk, ManagementInsuranceRiskCoveredTypeChoices.None]);

export function MoneyInputSchema(): yup.SchemaOf<MoneyInput> {
  return yup.object({
    amount: yup.mixed(),
    currency: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required()
  })
}

export function OfficeInputSchema(): yup.SchemaOf<OfficeInput> {
  return yup.object({
    address: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    city: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    country: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    main: yup.boolean().defined(),
    name: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    notActive: yup.boolean().defined(),
    registry: yup.string().required(),
    state: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    zip: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function PolicyAssetInputSchema(): yup.SchemaOf<PolicyAssetInput> {
  return yup.object({
    asset: yup.string(),
    catNat: yup.boolean(),
    coverTerrorism: yup.boolean(),
    coverType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    coveredRiskType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    deliveryAddress: yup.lazy(() => yup.mixed()) as never,
    evaluationType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    exemption: yup.boolean(),
    expiresAt: yup.mixed(),
    insuredValue: yup.lazy(() => yup.mixed()) as never,
    issuedAt: yup.mixed(),
    lenderAddress: yup.lazy(() => yup.mixed()) as never,
    lenderId: yup.string(),
    objectLocationEntityId: yup.string(),
    objectLocationOfficeId: yup.string(),
    pickupAddress: yup.lazy(() => yup.mixed()) as never,
    policy: yup.string(),
    shipperId: yup.string(),
    status: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function PolicyDocumentInputSchema(): yup.SchemaOf<PolicyDocumentInput> {
  return yup.object({
    description: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    extension: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    file: (yup.mixed().defined() as any).defined(),
    name: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    weight: yup.number()
  })
}

export function PolicyInputSchema(): yup.SchemaOf<PolicyInput> {
  return yup.object({
    autoRenewal: yup.boolean(),
    brokerId: yup.string().required(),
    catNat: yup.boolean(),
    contractingPartyId: yup.string().required(),
    coverTerrorism: yup.boolean(),
    coverType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    coveredRiskType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    evaluationType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    eventEntityId: yup.string().required(),
    eventFrom: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    eventLocationEntityId: yup.string().required(),
    eventName: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    eventTo: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    exemption: yup.boolean(),
    expiresAt: yup.mixed().defined(),
    hasVariableBasket: yup.boolean(),
    insuranceCompanyId: yup.string().required(),
    issuedAt: yup.mixed().defined(),
    offerCode: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    policyAssets: yup.array().of(yup.lazy(() => yup.mixed()) as never).optional(),
    policyCode: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    policyDocuments: yup.array().of(yup.lazy(() => yup.mixed()) as never).optional(),
    policyNote: yup.array().of(yup.lazy(() => yup.mixed()) as never).optional(),
    policyStatus: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    policyType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    totalInsuredPremium: yup.lazy(() => yup.mixed()) as never,
    totalInsuredValue: yup.lazy(() => yup.mixed()) as never
  })
}

export function PolicyNoteInputSchema(): yup.SchemaOf<PolicyNoteInput> {
  return yup.object({
    content: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    policyId: yup.string()
  })
}

export const RbacClientCustomerTypeChoicesSchema = yup.mixed().oneOf([RbacClientCustomerTypeChoices.Broker, RbacClientCustomerTypeChoices.Collector, RbacClientCustomerTypeChoices.InsuranceCompany, RbacClientCustomerTypeChoices.Museum]);

export const RbacClientTierChoicesSchema = yup.mixed().oneOf([RbacClientTierChoices.A_1, RbacClientTierChoices.A_2, RbacClientTierChoices.A_3]);

export function RegistryInputSchema(): yup.SchemaOf<RegistryInput> {
  return yup.object({
    activityPeriod: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    activityPlace: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    alias: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    artisticMovement: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    authorType: yup.array().of(yup.string().transform((value) =>( value === null ? undefined:value)).nullable()).optional(),
    billingAddress: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    birthDate: yup.mixed(),
    birthPlace: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    businessName: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    categories: yup.array().of(yup.string().transform((value) =>( value === null ? undefined:value)).nullable()).optional(),
    company: yup.string(),
    confidentialNotes: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    contactDescription: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    countryCode: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    deathDate: yup.mixed(),
    deathPlace: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    displayName: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    email: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    foundation: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    fullName: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    isAuthor: yup.boolean(),
    isBrokerDefaultTenantDefault: yup.boolean(),
    isCompany: yup.boolean(),
    isInsuranceCompanyTenantDefault: yup.boolean(),
    mainContact: yup.boolean(),
    mobilePhone: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    note: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    phone: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    printCode: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    printName: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    taxId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    webSite: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function RequestUserResetPasswordInputSchema(): yup.SchemaOf<RequestUserResetPasswordInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    email: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required()
  })
}

export function ResetUserPasswordInputSchema(): yup.SchemaOf<ResetUserPasswordInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    confirmPassword: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    newPassword: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    resetPasswordToken: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export function SignCertificateInputSchema(): yup.SchemaOf<SignCertificateInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string()
  })
}

export const SpinCertificateCertificateTypeChoicesSchema = yup.mixed().oneOf([SpinCertificateCertificateTypeChoices.PermanentCollection, SpinCertificateCertificateTypeChoices.TemporaryExhibition]);

export function ToggleUserIsActiveInputSchema(): yup.SchemaOf<ToggleUserIsActiveInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function ToggleUserUserTypeInputSchema(): yup.SchemaOf<ToggleUserUserTypeInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    expiration: yup.mixed(),
    id: yup.string().required()
  })
}

export function UpdateAssetElementInputSchema(): yup.SchemaOf<UpdateAssetElementInput> {
  return yup.object({
    assetElementData: yup.lazy(() => yup.mixed()) as never,
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function UpdateAssetInputSchema(): yup.SchemaOf<UpdateAssetInput> {
  return yup.object({
    assetData: yup.lazy(() => yup.mixed()) as never,
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function UpdateAssetPresentValueInputSchema(): yup.SchemaOf<UpdateAssetPresentValueInput> {
  return yup.object({
    assetPresentValueData: yup.lazy(() => yup.mixed()) as never,
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required()
  })
}

export function UpdateCertificateInputSchema(): yup.SchemaOf<UpdateCertificateInput> {
  return yup.object({
    certificateData: yup.lazy(() => yup.mixed()) as never,
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string()
  })
}

export function UpdateInsuranceInputSchema(): yup.SchemaOf<UpdateInsuranceInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required(),
    insuranceData: yup.lazy(() => yup.mixed()) as never
  })
}

export function UpdateOfficeInputSchema(): yup.SchemaOf<UpdateOfficeInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required(),
    officeData: yup.lazy(() => yup.mixed()) as never
  })
}

export function UpdatePolicyAssetInputSchema(): yup.SchemaOf<UpdatePolicyAssetInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required(),
    policyAssetData: yup.lazy(() => yup.mixed()) as never
  })
}

export function UpdatePolicyDocumentInputSchema(): yup.SchemaOf<UpdatePolicyDocumentInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required(),
    policyDocumentData: yup.lazy(() => yup.mixed()) as never
  })
}

export function UpdatePolicyInputSchema(): yup.SchemaOf<UpdatePolicyInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required(),
    policyData: yup.lazy(() => yup.mixed().defined()) as never
  })
}

export function UpdatePolicyNoteInputSchema(): yup.SchemaOf<UpdatePolicyNoteInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required(),
    policyNoteData: yup.lazy(() => yup.mixed()) as never
  })
}

export function UpdateRegistryInputSchema(): yup.SchemaOf<UpdateRegistryInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required(),
    registryData: yup.lazy(() => yup.mixed()) as never
  })
}

export function UpdateUserInputSchema(): yup.SchemaOf<UpdateUserInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    id: yup.string().required(),
    userData: yup.lazy(() => yup.mixed().defined()) as never
  })
}

export function UpdateUserPermissionInputSchema(): yup.SchemaOf<UpdateUserPermissionInput> {
  return yup.object({
    clientMutationId: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    email: yup.string().transform((value) =>( value === null ? undefined:value)).nullable().required(),
    permissions: yup.array().of(yup.string().transform((value) =>( value === null ? undefined:value)).nullable()).optional()
  })
}

export function UserInputSchema(): yup.SchemaOf<UserInput> {
  return yup.object({
    country: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    currency: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    expiresAt: yup.mixed(),
    language: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    name: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    phone: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    timezone: yup.string().transform((value) =>( value === null ? undefined:value)).nullable(),
    userType: yup.string().transform((value) =>( value === null ? undefined:value)).nullable()
  })
}

export const UsersUserUserTypeChoicesSchema = yup.mixed().oneOf([UsersUserUserTypeChoices.Default, UsersUserUserTypeChoices.External, UsersUserUserTypeChoices.Internal]);
